import { createApi } from "@reduxjs/toolkit/query/react";
import { components } from "../../types/api";
import { baseQueryWithReauth } from "../../utils/baseQuery";

export type HivestackAdvertiser = components["schemas"]["HiveStackAdvertiser"];

type ApiResponseHivestackAdvertisersResponse =
  components["schemas"]["ApiResponse_HivestackAdvertisersResponse_"];

export type HivestackAdvertisersResponse =
  components["schemas"]["HivestackAdvertisersResponse"];

export const hivestackApi = createApi({
  reducerPath: "hivestackApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["HivestackAdvertisers"],
  endpoints: (builder) => ({
    getAdvertisers: builder.query<HivestackAdvertisersResponse, void>({
      query: () => "/hivestack/advertisers",
      providesTags: ["HivestackAdvertisers"],
      transformResponse: (
        response: ApiResponseHivestackAdvertisersResponse
      ): HivestackAdvertisersResponse => response.data ?? [],
    }),
  }),
});

export const { useGetAdvertisersQuery, useLazyGetAdvertisersQuery } =
  hivestackApi;
